document.addEventListener("DOMContentLoaded", () => {
  const collectionWrappers = document.querySelectorAll(".collection-wrapper");

  const formatNumber = (number) => (number < 10 ? `0${number}` : `${number}`);

  if (typeof EmblaCarousel === "undefined") {
    console.error("EmblaCarousel is not loaded");
    return;
  }

  collectionWrappers.forEach((wrapper) => {
    const imageEmblaEl = wrapper.querySelector(".collection-images");
    const textEmblaEl = wrapper.querySelector(".collection-full");
    const currentSlideEl = wrapper.querySelector(".current-slide");

    if (!imageEmblaEl || !textEmblaEl) {
      console.warn("Embla elements not found", { imageEmblaEl, textEmblaEl });
      return;
    }

    const imageContainer = imageEmblaEl.querySelector(".embla__container");
    const textContainer = textEmblaEl.querySelector(".embla__container");

    const originalTotal = imageContainer
      ? imageContainer.children.length
      : imageEmblaEl.querySelectorAll(".embla__slide").length;

    // Embla puede desactivar loop si detecta pocos slides.
    // Con 2 slides duplicamos internamente para que loop/swipe funcione bien.
    if (originalTotal === 2 && imageContainer && textContainer) {
      [...imageContainer.children].forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        imageContainer.appendChild(clone);
      });

      [...textContainer.children].forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        textContainer.appendChild(clone);
      });
    }

    const imageEmbla = EmblaCarousel(imageEmblaEl, {
      loop: true,
      align: "start",
      containScroll: false,
      dragFree: false,
      watchDrag: true,
    });

    const textEmbla = EmblaCarousel(textEmblaEl, {
      loop: true,
      align: "start",
      containScroll: false,
      watchDrag: false,
      duration: 0,
    });

    let pointerDownX = 0;
    let pointerDownY = 0;
    let hasDragged = false;

    const getRealIndex = () => {
      const snap = imageEmbla.selectedScrollSnap();
      return imageEmbla.slideNodes()[snap]?.dataset.productIndex || 0;
    };
    const viewProductLink = wrapper.querySelector(".view-product-link");
    const productUrls = [...imageContainer.children].slice(0, originalTotal).map((slide) => slide.dataset.productUrl);

    const updateViewProductLink = () => {
      if (!viewProductLink) return;

      const currentIndex = Number(getRealIndex());
      const productUrl = productUrls[currentIndex];

      if (productUrl) {
        viewProductLink.href = productUrl;
      }
    };

    const updateCounter = () => {
      if (!currentSlideEl) return;

      const current = imageEmbla.selectedScrollSnap() + 1;

      currentSlideEl.textContent = `${formatNumber(current)} / ${formatNumber(originalTotal)}`;
    };

    const syncCarousels = () => {
      textEmbla.scrollTo(imageEmbla.selectedScrollSnap(), true);
      updateCounter();
      updateViewProductLink();
    };
    imageEmbla.on("select", syncCarousels);
    imageEmbla.on("reInit", updateCounter);

    imageEmblaEl.addEventListener("mousemove", (event) => {
      const rect = imageEmblaEl.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const isLeftSide = mouseX < rect.width / 2;

      imageEmblaEl.classList.toggle("is-left-side", isLeftSide);
      imageEmblaEl.classList.toggle("is-right-side", !isLeftSide);
    });

    imageEmblaEl.addEventListener("mouseleave", () => {
      imageEmblaEl.classList.remove("is-left-side", "is-right-side");
    });

    imageEmblaEl.addEventListener("pointerdown", (event) => {
      pointerDownX = event.clientX;
      pointerDownY = event.clientY;
      hasDragged = false;
    });

    imageEmblaEl.addEventListener("pointermove", (event) => {
      const diffX = Math.abs(event.clientX - pointerDownX);
      const diffY = Math.abs(event.clientY - pointerDownY);

      if (diffX > 8 || diffY > 8) {
        hasDragged = true;
      }
    });

    imageEmblaEl.addEventListener("click", (event) => {
      const clickedLink = event.target.closest(".collection-product-link");

      if (hasDragged) {
        event.preventDefault();
        return;
      }

      if (clickedLink) return;

      const rect = imageEmblaEl.getBoundingClientRect();
      const clickX = event.clientX - rect.left;
      const isLeftSide = clickX < rect.width / 2;

      isLeftSide ? imageEmbla.scrollPrev() : imageEmbla.scrollNext();
    });

    updateCounter();
    updateViewProductLink();

    window.addEventListener("load", () => {
      imageEmbla.reInit();
      textEmbla.reInit();
      updateCounter();
      updateViewProductLink();
    });
  });
});
